import {
  Ban,
  CircleCheck,
  CircleQuestionMark,
  CircleX,
  MapPin,
  Package,
  PackageCheck,
  TriangleAlert,
  Truck,
} from 'lucide-react';
import LangEnum from '../../../lang/LangEnum';
import type { ActivityFeedStatusChip } from './activityFeedPhrase.types';

export const SHIPMENT_DATE_FORMAT = 'dd/MM/yy';

export const ShipmentStatus = {
  PROCESSING: 'PROCESSING',
  READY_FOR_PICKUP: 'READY_FOR_PICKUP',
  IN_TRANSIT: 'IN_TRANSIT',
  OUT_FOR_DELIVERY: 'OUT_FOR_DELIVERY',
  DELIVERED: 'DELIVERED',
  DELIVERY_EXCEPTION: 'DELIVERY_EXCEPTION',
  DELIVERY_FAILED: 'DELIVERY_FAILED',
  CANCELED: 'CANCELED',
  UNKNOWN: 'UNKNOWN',
} as const;

export type ShipmentStatus = (typeof ShipmentStatus)[keyof typeof ShipmentStatus];

export const SHIPMENT_CHIP_BY_STATUS: Record<ShipmentStatus, ActivityFeedStatusChip> = {
  [ShipmentStatus.PROCESSING]: {
    label: LangEnum.SHIPMENT_STATUS_PROCESSING,
    icon: Package,
    color: 'neutral',
  },
  [ShipmentStatus.READY_FOR_PICKUP]: {
    label: LangEnum.SHIPMENT_STATUS_READY_FOR_PICKUP,
    icon: PackageCheck,
    color: 'waiting',
  },
  [ShipmentStatus.IN_TRANSIT]: {
    label: LangEnum.SHIPMENT_STATUS_IN_TRANSIT,
    icon: Truck,
    color: 'progress',
  },
  [ShipmentStatus.OUT_FOR_DELIVERY]: {
    label: LangEnum.SHIPMENT_STATUS_OUT_FOR_DELIVERY,
    icon: MapPin,
    color: 'progress',
  },
  [ShipmentStatus.DELIVERED]: {
    label: LangEnum.SHIPMENT_STATUS_DELIVERED,
    icon: CircleCheck,
    color: 'success',
  },
  [ShipmentStatus.DELIVERY_EXCEPTION]: {
    label: LangEnum.SHIPMENT_STATUS_DELIVERY_EXCEPTION,
    icon: TriangleAlert,
    color: 'waiting',
  },
  [ShipmentStatus.DELIVERY_FAILED]: {
    label: LangEnum.SHIPMENT_STATUS_DELIVERY_FAILED,
    icon: CircleX,
    color: 'error',
  },
  [ShipmentStatus.CANCELED]: {
    label: LangEnum.SHIPMENT_STATUS_CANCELED,
    icon: Ban,
    color: 'closed',
  },
  [ShipmentStatus.UNKNOWN]: {
    label: LangEnum.SHIPMENT_STATUS_UNKNOWN,
    icon: CircleQuestionMark,
    color: 'neutral',
  },
};

export const findShipmentStatusChip = (status: string): ActivityFeedStatusChip | null =>
  SHIPMENT_CHIP_BY_STATUS[status.toUpperCase() as ShipmentStatus] ?? null;
